<template>
  <div class="logistics-info">
    <div class="return-goods logistics-info-mod">
      <div class="mod-title">售后商品</div>
      <div
        v-for="(item, index) in orderInfo.cartInfo"
        :key="index"
        class="return-goods-container"
      >
        <div class="good-img-text">
          <div class="good-img">
            <img :src="item.productInfo.image" />
          </div>
          <div class="good-text">
            <div class="good-title-value">
              <div class="good-title">{{ item.productInfo.store_name }}</div>
              <div class="good-value">{{ item.productInfo.attrInfo.suk }}</div>
            </div>
            <div class="amount">￥{{ item.productInfo.attrInfo
                ? item.productInfo.attrInfo.price
                : item.productInfo.price }}</div>
          </div>
        </div>
        <div class="good-count">
          <div class="count">×{{ item.cart_num }}</div>
        </div>
      </div>
    </div>
    <div class="return-info logistics-info-mod">
      <div class="mod-title">选择服务类型</div>
      <div class="service-list">
        <div
          v-for="(item,index) in AftersaleList" 
          :key="index"
          @click="SelectAftersale(item)"
          class="service-item">
          <div class="service-icon-text">
            <div
              :class="'icon-' + item.icon" 
              class="iconfont"></div>
            <div class="text">
              <div>{{item.name}}</div>
              <div class="text-desc">{{item.remark}}</div>
            </div>
          </div>
          <van-icon name="arrow" color="#b7b7b7"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { orderDetail , getAftersaleList} from "@api/order";
import { getUserInfo } from "@api/user";
import Icon from "vant/lib/icon";
import "vant/lib/icon/style";
export default {
  name: "OrderServiceList",
  components: {
    [Icon.name]: Icon,
  },
  data() {
    return {
      order_id: "", //订单id
      orderInfo: {}, //订单信息
      userInfo: {},
      AftersaleList:[] //选择服务列表
    };
  },
  mounted() {
    this.order_id = this.$route.params.order_id;
    this.getOrderDetail();
    this.getAftersaleList();
    this.getUserInfo();
  },
  methods: {
    /**
     * 获取订单信息
     */
    getOrderDetail() {
      orderDetail(this.order_id).then((res) => {
        if(res.status === 200){
          this.orderInfo = res.data;
        }else{
          this.$dialog.message(res.msg);
        }
        
      }).catch(err => {
        this.$dialog.error(err.msg);
      });
    },
    
    /**
     * 用户信息
     */
    getUserInfo() {
      getUserInfo().then((res) => {
        if(res.status === 200){
          this.userInfo = res.data;
        }else{
          this.$dialog.message(res.msg)
        }
        
      }).catch(err => {
        this.$dialog.error(err.msg)
      });
    },
    /**
     * 售后服务类型列表
     */
    getAftersaleList(){
      getAftersaleList(this.order_id).then(res => {
        if(res.status === 200){
          this.AftersaleList = res.data;
        }else{
          this.$dialog.message(res.msg);
        }
      }).catch(err => {
        this.$dialog.error(err.msg);
      })
    },
    /**
     * 选择售后类型
     */
    SelectAftersale(item){
      if(item.type === 1) return this.$router.push({path:'/order/refund/' + this.order_id + '?id=' + item.id});
      if(item.type === 2) return this.$router.push({path:'/order/after_sale/' + this.order_id + '?id=' + item.id});
    }
    
    
    
    
  },
};
</script>
<style scoped>
.logistics-info {
  padding: 0 0.2rem;
}
.return-goods {
  background: #fff;
  padding: 0.2rem;
  margin-top: 0.3rem;
  border-radius: 10px;
  box-shadow: 0px 2px 9px #f1f1f1;
}
.logistics-info-mod {
  background: #fff;
  padding: 0.2rem;
  margin-top: 0.3rem;
  border-radius: 10px;
  box-shadow: 0px 2px 9px #f1f1f1;
}
.mod-title {
  font-size: 0.3rem;
  font-weight: 800;
  margin-bottom: 0.16rem;
}
.return-goods-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 1.7rem;
}

.return-goods-container .good-img-text {
  display: flex;
}
.return-goods-container .good-img {
  width: 25%;
  margin-right: 0.2rem;
}
.good-img-text .good-text {
  display: flex;
  flex-wrap: wrap;
}
.good-text .good-title-value {
  width: 100%;
}
.good-title-value .good-title {
  font-size: 0.28rem;
  font-weight: 500;
  color: #000;
}
.good-title-value .good-value {
  color: #a0a0a0;
  font-size: 0.26rem;
  margin-top: 0.06rem;
}
.return-goods-container .amount-count {
  /* width: 20%; */
}
.good-img img {
  width: 100%;
}
.good-count .count {
  font-size: 0.28rem;
  color: #a0a0a0;
}
.service-list .service-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .2rem 0;
  border-bottom: 1px solid #f5f5f5;
}
.service-list .service-item:last-of-type{
  border-bottom: none;
  padding-bottom: 0;
}
.service-list .service-item .text{
  font-size: 0.3rem;
  font-weight: 800;
  margin-left: .14rem;
  
}
.service-list .service-item .text .text-desc{
  font-size: .26rem;
  margin-top: .04rem;
  color: rgb(169, 169, 169);
  font-weight: normal;
  max-width: 5.06rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.service-list .service-item .iconfont{
  font-size: .48rem;
  /* font-weight: 600; */
  color: #f1ca9c;
}
.service-item .service-icon-text{
  display: flex;
  align-items: center;
}
</style>